var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { useComponents } from '@tencent/dz-elements';
import { useConsultModel, useMessageModel } from '../../hooks';
import styles from './index.less';
import { MessageMsgType, MessageMsgFrom, MessageType } from '@tencent/dz-models';
import { useReport } from '@tencent/dz-report';
import { DEFAULT_AVATAR_IMAGE } from '../../const';
import { formatRichText, formateImageWebp } from '../../utils';
export var DetailModal = function (props) {
    var children = props.children, _a = props.title, title = _a === void 0 ? '详情介绍' : _a, className = props.className, show = props.show, onHide = props.onHide, _b = props.height, height = _b === void 0 ? 560 : _b, _c = props.showGoTop, showGoTop = _c === void 0 ? false : _c, _d = props.showReplay, showReplay = _d === void 0 ? false : _d, _e = props.currentTime, currentTime = _e === void 0 ? Infinity : _e, reportModuleParams = props.reportModuleParams;
    var _f = useComponents(), Modal = _f.Modal, View = _f.View, Text = _f.Text, ScrollView = _f.ScrollView, Image = _f.Image;
    var consultConfig = useConsultModel().getConsultConfig();
    var report = useReport();
    var messageModel = useMessageModel();
    var _g = useState(showGoTop), isGoTop = _g[0], setIsGoTop = _g[1];
    var staffMessageNum = 0;
    var newestStaffMessage = {
        msgType: MessageMsgType.Text,
        message: '',
    };
    var isNewStaffMessage = function (message) {
        if (message.msg_time && message.msg_time > currentTime && message.msg_is_new) {
            return message.msg_from === MessageMsgFrom.Server && message.type === MessageType.Server;
        }
        return false;
    };
    if (show && showReplay) {
        // 获取打开弹窗后客服发送的消息
        var newStaffMessage = messageModel.messageQueue.filter(function (message) { return isNewStaffMessage(message); });
        staffMessageNum = newStaffMessage.length;
        if (staffMessageNum > 0) {
            var newestMessage = newStaffMessage[staffMessageNum - 1];
            newestStaffMessage.msgType = newestMessage.msg_type || MessageMsgType.Text;
            newestStaffMessage.message = newestMessage.payload.message;
        }
        else {
            newestStaffMessage.msgType = MessageMsgType.Text;
            newestStaffMessage.message = '';
        }
    }
    var goTop = function () {
        var scrollContainer = document.getElementById('deatil-modal-scroll');
        scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.scrollTo(0, 0);
    };
    var handleScroll = function () {
        if (isGoTop)
            return;
        setIsGoTop(true);
    };
    var onClose = function () {
        onHide();
        setIsGoTop(showGoTop);
    };
    var handleReply = function () {
        reportModuleParams && report.click(__assign(__assign({}, reportModuleParams.module), { element_id: staffMessageNum, element_type: reportModuleParams.payload.element_type, element_chinese_type: reportModuleParams.payload.element_chinese_type, element_content: newestStaffMessage.message }));
        onClose();
        // 调起键盘
        var dom = document.getElementById('message-input');
        dom === null || dom === void 0 ? void 0 : dom.focus();
    };
    var getAvatar = function () {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        var hospital_config = consultConfig.hospital_config, staff_img_url = consultConfig.staff_img_url;
        if (hospital_config) {
            return hospital_config.logo || DEFAULT_AVATAR_IMAGE;
        }
        return staff_img_url || DEFAULT_AVATAR_IMAGE;
    };
    var renderMessage = function () {
        var msgType = newestStaffMessage.msgType, message = newestStaffMessage.message;
        switch (msgType) {
            case MessageMsgType.Rich:
                return React.createElement("div", { dangerouslySetInnerHTML: { __html: formatRichText(message) }, className: styles['message-content'] + " " + styles['message-rich'] });
            case MessageMsgType.Image:
                return React.createElement(Image, { src: formateImageWebp(message), imageWidth: 100, imageHeight: 100, className: styles['message-img'] });
            default:
                return React.createElement(Text, { className: styles['message-content'], content: message });
        }
    };
    return (React.createElement(React.Fragment, null, show && (React.createElement(Modal, { show: true, maskColor: "rgba(0,0,0,.45)", style: {
            position: 'absolute',
            bottom: 0,
            height: height,
            backgroundColor: '#FFF',
            width: '100%',
            maxWidth: '100%',
        }, className: styles['modal-container'] + " " + className, maskClosable: true, onHide: onClose, id: "search-modal" },
        React.createElement(View, { className: styles['modal-header'] },
            React.createElement(Text, { className: styles['modal-title'], content: title }),
            React.createElement(View, { className: styles['modal-close'], onClick: onClose })),
        React.createElement(ScrollView, { style: { padding: 15 }, id: "deatil-modal-scroll", className: styles['deatil-modal-scroll'], onScroll: handleScroll },
            children,
            isGoTop && (React.createElement(View, { className: styles['go-top'], onClick: goTop },
                React.createElement(View, { className: styles['content-top'] }, "\u8FD4\u56DE\u9876\u90E8"),
                React.createElement(View, { className: styles['arrow-top'] }))),
            React.createElement(View, { style: { height: 15 } })),
        showReplay && React.createElement(View, { className: isGoTop ? styles['detail-modal-replay'] + " " + styles['reply-shadow'] : styles['detail-modal-replay'] },
            React.createElement(View, { className: styles['new-message-wrap'], onClick: handleReply },
                React.createElement(View, { className: styles['server-logo'] },
                    React.createElement(Image, { className: styles.logo, src: formateImageWebp(getAvatar()), imageWidth: 30, imageHeight: 30 }),
                    staffMessageNum > 0 && React.createElement(View, { className: styles['message-num'] },
                        React.createElement(View, { className: staffMessageNum > 99 ? styles['to-much-num'] : styles.num }, staffMessageNum > 99 ? '99+' : staffMessageNum))),
                React.createElement(View, { className: styles.message }, renderMessage())),
            React.createElement(View, { className: styles['replay-button'], onClick: handleReply }, "\u7ACB\u5373\u56DE\u590D"))))));
};
